import type { CompanyDetail, CreateScanResponse, ListScansResponse, ScanLogDto } from "@mvk/shared";
import { resolveBoothDisplayQrCode } from "@mvk/shared";
import { apiRequest } from "../api/client";

export const scanApi = {
  create(
    eventId: string,
    codeValue: string,
    codeType: "qr" | "barcode" = "qr",
    idempotencyKey?: string,
  ) {
    return apiRequest<CreateScanResponse>(`/events/${eventId}/scans`, {
      method: "POST",
      body: { codeValue, codeType },
      audience: "visitor",
      idempotencyKey,
    });
  },

  list(eventId: string) {
    return apiRequest<ListScansResponse>(`/events/${eventId}/scans`, {
      audience: "visitor",
    });
  },

  updateNotes(
    eventId: string,
    scanId: string,
    body: { notes?: string; tags?: string[] },
  ) {
    return apiRequest<{ scan: ScanLogDto }>(`/events/${eventId}/scans/${scanId}`, {
      method: "PATCH",
      body,
      audience: "visitor",
    });
  },
};

export function companyDetailToUiCompany(detail: CompanyDetail) {
  return {
    id: detail.id,
    eventId: detail.eventId,
    name: detail.name,
    category: detail.category,
    tags: [] as string[],
    hall: detail.hall ?? "",
    booth: detail.booth ?? "",
    shortAbout: detail.shortAbout,
    products: [] as string[],
    website: detail.website,
    contact: {
      phone: detail.phone,
      email: detail.email,
    },
    logoUrl: detail.logoUrl,
    qrCodeValue: resolveBoothDisplayQrCode(detail),
    boothQrCode: detail.boothQrCode,
    mapPoint: { x: 0, y: 0, hallId: "" },
  };
}
